const MAX_FILENAME = 16;

export type FileEntry = {
  id: string;
  file: File;
  previewUrl: string;
  type: 'image' | 'video' | 'audio' | 'document';
};

const inferType = (mimeType: string): FileEntry['type'] => {
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.startsWith('video/')) return 'video';
  if (mimeType.startsWith('audio/')) return 'audio';
  return 'document';
};

export const createFileEntry = (file: File): FileEntry => ({
  id: `${file.name}-${file.size}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  file,
  previewUrl: URL.createObjectURL(file),
  type: inferType(file.type),
});

const truncateName = (name: string): string =>
  name.length > MAX_FILENAME ? name.slice(0, MAX_FILENAME) + '\u2026' : name;

function FileThumb({ entry, onRemove }: { entry: FileEntry; onRemove: (id: string) => void }) {
  const name = truncateName(entry.file.name);

  return (
    <div className="file-thumb" key={entry.id}>
      {entry.type === 'image' ? (
        <img src={entry.previewUrl} alt={entry.file.name} className="file-thumb-media" />
      ) : entry.type === 'video' ? (
        <video src={entry.previewUrl} className="file-thumb-media" muted />
      ) : (
        <div className="file-thumb-icon">
          <span className="file-thumb-emoji" aria-hidden="true">
            {entry.type === 'audio' ? '\uD83C\uDFB5' : '\uD83D\uDCC4'}
          </span>
          <span className="file-thumb-name">{name}</span>
        </div>
      )}
      <button
        type="button"
        className="file-thumb-remove"
        onClick={() => onRemove(entry.id)}
        aria-label="Bestand verwijderen"
      >
        \u2715
      </button>
    </div>
  );
}

export default function FilePreviewBar({
  files,
  onRemove,
}: {
  files: FileEntry[];
  onRemove: (id: string) => void;
}) {
  if (files.length === 0) return null;

  return (
    <div className="file-preview-bar" role="list" aria-label="Geselecteerde bestanden">
      {files.map((entry) => (
        <FileThumb key={entry.id} entry={entry} onRemove={onRemove} />
      ))}
    </div>
  );
}
